import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterParametrosAvancados,
    atualizarParametrosAvancados,
} from "../../../services/configuracaoDeliveryFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ParametrosAvancadosInicial } from "../models/parametrosAvancadosModel"
import { ParametrosAvancadosActionsTypes } from "./parametrosAvancadosActions"
import { ParametrosAvancadosContext } from "./ParametrosAvancadosContext"
import { parametrosAvancadosReducer } from "./parametrosAvancadosReducer"

export function ParametrosAvancadosContextProvider({ children }: { children: React.ReactNode }) {
    const [parametros, dispatch] = useReducer(parametrosAvancadosReducer, ParametrosAvancadosInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterParametrosAvancados(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar parâmetros avançados")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ParametrosAvancadosActionsTypes.CARREGAR,
                    payload: { ...ParametrosAvancadosInicial, ...response },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar parâmetros avançados")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await atualizarParametrosAvancados(autorizacao, parametros)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            dispatch({
                type: ParametrosAvancadosActionsTypes.CARREGAR,
                payload: { ...ParametrosAvancadosInicial, ...response },
            })
        } finally {
            setLoading(false)
        }
    }, [parametros, setLoading])

    return (
        <ParametrosAvancadosContext.Provider value={{ parametros, dispatch, salvar, erroCarregamento }}>
            <Loading />
            {children}
        </ParametrosAvancadosContext.Provider>
    )
}
